module.exports = __webpack_public_path__ + "static/don5-da645eb9d8948734b5cb7fca5221d4b7.jpg";